document.addEventListener('DOMContentLoaded', function() {
  // Select all links with hashes
  document.querySelectorAll('a[href*="#"]').forEach(link => {
    // Remove links that don't actually link to anything
    if (
      link.getAttribute('href') === '#' ||
      link.getAttribute('href') === '#0' ||
      link.getAttribute('role') === 'button'
    ) {
      return;
    }

    link.addEventListener('click', function(event) {
      console.log('anchor scroll');
      // On-page links
      if (
        location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') 
        && 
        location.hostname === this.hostname
      ) {
        // Figure out element to scroll to
        const hash = this.hash;
        let target = document.querySelector(hash);
        if (!target) {
          target = document.querySelector(`[name="${hash.slice(1)}"]`);
        }
        // Does a scroll target exist?
        if (target) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

          // Callback after animation - use setTimeout to approximate animation duration
          setTimeout(function() {
            // Must change focus!
            target.focus();
            if (document.activeElement !== target) { // Checking if the target was focused
              target.setAttribute('tabindex', '-1'); // Adding tabindex for elements not focusable
              target.focus(); // Set focus again
            }
          }, 1200);
        }
      }
    });
  });
});